import { render, staticRenderFns } from "./ColmenaEditar.vue?vue&type=template&id=49562eec&scoped=true&"
import script from "./ColmenaEditar.vue?vue&type=script&lang=js&"
export * from "./ColmenaEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49562eec",
  null
  
)

export default component.exports